import { payOrderApi } from '@/api/order'
import payAgain from './payAgain'
import store from '@/store'

/**
 * 
 * @param {*} param0 
 * @param {object} data
 * @param {string} data.order_sn - 订单编号
 * @param {string} data.pay_type - 支付方式（1 积分支付 | 2 余额支付 | 3 微信支付 | 21 福利卡支付 | 20 混合支付 )
 * @param {array} data.pay_details - 混合支付使用 ('可选')
 * @param {string} data.pay_details[].pay_type - 支付方式（1 积分支付 | 2 余额支付 | 3 微信支付 | 21 福利卡支付 | 20 混合支付 )
 * @param {string} data.pay_details[].pay_money - 支付金额
 * @param {number} data.weal_id - 福利卡id ('可选')
 * @param {number} data.card_id - 优惠券卡券id ('可选')
 * @param {number} data.shop_id - 新福利卡id ('可选')
 * 
 * @returns
 */

async function payOrder ({ state, getters, dispatch }, data) {
  const { order_sn } = data
  const result = await payOrderApi({
    order_sn,
    pay_type: data.pay_type,
    pay_details: data.pay_details || undefined,
    weal_id: data.weal_id || undefined,
    card_id: data.card_id || undefined,
    shop_id: data.shop_id || undefined
  })
  
  return result.data.data
  // if (result.data.data.status) {
  //   const payInfo = result.data.data.pay_info
  //   payInfo.order_sn = data.order_sn
  //   return await payAgain(
  //     { state, getters, dispatch },
  //     payInfo,
  //   )
  // } else {
  //   return Promise.reject(result.data.data.msg)
  // }
}

export default payOrder
